<!--dialog 供应商信息 由于运维服务已经挪走减少了判断-->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1200px"
      @close="cancel"
      :class="[
        sourcePage === 'sourcingFlow' ? 'dialog-sourcingflow-zindex' : ''
      ]"
      class="dialog-zindex ccui-multifunctional-table-wrapper-detail dic-dialog-supplier-detail"
    >
      <div style="height:508px">
        <anchorTitle
          :tabBtn="tabBtn"
          :isFocus="isFocus"
          @tabBtnChange="tableTopChange"
        />
        <div>
          <!--基本信息-->
          <div v-show="isFocus === '1'">
            <basicInfo
              labelWidth="160px"
              :fieldList="detailBaseInfo.supplierBaseInfo"
              :data-info="basicInfoData"
            ></basicInfo>
          </div>
          <!--联系信息-->
          <div v-show="isFocus === '2'">
            <basicInfo
              labelWidth="160px"
              :fieldList="detailBaseInfo.supplierContact"
              :data-info="supplierContactData"
            ></basicInfo>
            <!--常用联系人信息-->
            <supplierTable
              title="常用联系人信息"
              :table-head="detailBaseInfo.supplierCommonLinkInfo"
              :table-data="commonLinkInfoData"
            ></supplierTable>
          </div>
          <!--产品信息-->
          <div v-show="isFocus === '3'">
            <supplierTable
              :table-head="detailBaseInfo.productInfo"
              :table-data="productInfoData"
            ></supplierTable>
          </div>
          <!--财务信息-->
          <div v-show="isFocus === '4'">
            <basicInfo
              label-width="160px"
              :fieldList="detailBaseInfo.financeInfo"
              :data-info="financeInfoData"
            ></basicInfo>
          </div>
          <!--合作业绩-->
          <div v-show="isFocus === '5'">
            <basic-info
              label-width="160px"
              :fieldList="detailBaseInfo.cooperationPerformance"
              :data-info="cooperationPerformanceData"
            ></basic-info>
          </div>
          <!--签订合同业绩-->
          <div v-show="isFocus === '6'">
            <supplierTable
              :table-head="detailBaseInfo.signContract"
              :table-data="signContractData"
            ></supplierTable>
          </div>
          <!--供应商考核-->
          <div v-show="isFocus === '7'">
            <supplierAssessment
              :table-data="supplierAssessmentData"
            ></supplierAssessment>
          </div>
          <!--资质文件-->
          <div v-show="isFocus === '8'">
            <supplierTable
              :table-head="detailBaseInfo.certificates"
              :table-data="certificatesData"
            >
              <template slot="opp" slot-scope="{ row }">
                <a
                  class="icon-ccui-link"
                  :href="row.fileUrl"
                  :download="row.fileUrl"
                ></a>
              </template>
            </supplierTable>
          </div>
          <!--状态信息-->
          <div v-show="isFocus === '9'">
            <supplierTable
              :table-head="detailBaseInfo.statusInfo"
              :table-data="statusInfoData"
            ></supplierTable>
          </div>
          <!--历史中标金额-->
          <div v-show="isFocus === '10'">
            <supplierSummaryTable
              :table-data="historyBidAmount"
            ></supplierSummaryTable>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  querySupplierFrozenOrDisableStatusList,
  qrySupBaseInfo,
  qrySupplierQualificationFile,
  qrySupHisPerform,
  qrySupFinanceInfo,
  qrySupplierProductInfo,
  qrySupplierLinkInfo,
  qryAssessScoreInfoList,
  qrySupBidAmountList,
  qrySignContract
} from "@/app/sourcingFlow/api/supplier";

import detailBaseInfo from "@/setting/detail-base-info";
import basicInfo from "./dialogSupplierDetail/basic-info";
import supplierTable from "./dialogSupplierDetail/supplier-table";
import supplierAssessment from "./dialogSupplierDetail/supplier-assessment";
import supplierSummaryTable from "./dialogSupplierDetail/supplier-summary-table";
import moment from "moment";
export default {
  name: "dialogSupplierDetail",
  props: {
    sourcePage: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: "供应商信息"
    },
    supplierDialogData: {
      type: Object,
      default() {
        return {
          businessBillType: "",
          supCode: "",
          supinfoId: "",
          supName: ""
        };
      }
    },
    supplierVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    basicInfo,
    supplierTable,
    supplierAssessment,
    supplierSummaryTable
  },
  data() {
    return {
      basicInfoData: {}, //基本信息
      supplierContactData: {}, //供应商联系信息
      commonLinkInfoData: [], //常用联系人信息
      productInfoData: [], //产品信息
      financeInfoData: {}, //财务信息
      cooperationPerformanceData: {}, //合作业绩
      signContractData: [], //签订合同业绩 暂无数据
      supplierAssessmentData: [], // 供应商考核信息
      certificatesData: [], //资质文件信息
      statusInfoData: [], //状态信息
      historyBidAmount: [], //历史中标金额
      isFocus: "1",
      tabBtn: [
        {
          label: "基本信息",
          value: "1"
        },
        {
          label: "联系信息",
          value: "2"
        },
        {
          label: "产品信息",
          value: "3"
        },
        {
          label: "财务信息",
          value: "4"
        },
        {
          label: "合作业绩",
          value: "5"
        },
        {
          label: "签订合同业绩",
          value: "6"
        },
        {
          label: "供应商考核",
          value: "7"
        },
        {
          label: "资质文件",
          value: "8"
        },
        {
          label: "状态信息",
          value: "9"
        },
        {
          label: "历史中标金额",
          value: "10"
        }
      ],
      detailBaseInfo: detailBaseInfo
    };
  },
  computed: {
    visible: {
      get() {
        if (this.supplierVisible) {
          this.getAllData();
        }
        console.log(document.body.offsetHeight);
        return this.supplierVisible;
      },
      set(val) {
        this.$emit("update:supplierDetailDialog", val);
      }
    }
  },
  methods: {
    getAllData() {
      // 请求供应商基本信息
      this.getBasicInfoData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 请求供应商联系信息 和常用联系人信息
      this.getSupplierContactData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 产品信息
      this.getProductInfoData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 财务信息
      this.getFinanceInfoData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 合作业绩
      this.getCooperationPerformanceData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 资质文件
      this.getCertificatesData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 请求供应商考核数据
      this.getAssessScoreInfoList(
        this.supplierDialogData.supName,
        this.supplierDialogData.supCode
      );
      // 请求签订合同业绩
      this.getSignContractData(
        this.supplierDialogData.supName,
        this.supplierDialogData.supCode
      );
      // 查询状态信息
      this.getStatusInfoData(
        this.supplierDialogData.supinfoId,
        this.supplierDialogData.businessBillType,
        this.supplierDialogData.supCode
      );
      // 查询历史中标金额
      this.getHistoryBidAmount(this.supplierDialogData.supCode);
    },
    // 请求基本信息
    getBasicInfoData(supid, businessBillType, supcode) {
      let params = {
        supinfoId: supid,
        businessBillType: businessBillType,
        supCode: supcode,
        requestLimit: true
      };
      //基本信息
      qrySupBaseInfo(params).then(res => {
        if (res.data.code === "0") {
          let item = Object.assign(
            {},
            res.data.data.supBaseInfoBO,
            res.data.data.supAccountInfoBO
          );
          for (let i in item) {
            if (i === "isOutSup" || i === "isInIndy") {
              item[i + "Comp"] = item[i] === 1 ? "是" : "否";
            }
          }
          item.location = `${item.locationName || ""}${item.provinceName ||
            ""}${item.cityName || ""}${item.countyName || ""}`;
          this.basicInfoData = item || {};
          // 审批操作信息
          // this.approvalOperInfoBO = res.data.data.approvalOperInfoBO
        }
      });
    },
    // 请求供应商联系信息 和常用联系人信息
    getSupplierContactData(supid, businessBillType, supcode) {
      let params = {
        supinfoId: supid,
        businessBillType: businessBillType,
        supCode: supcode,
        requestLimit: true
      };
      qrySupBaseInfo(params).then(res => {
        if (res.data.code === "0") {
          let item = Object.assign(
            {},
            res.data.data.supBaseInfoBO,
            res.data.data.supAccountInfoBO
          );
          for (let i in item) {
            if (i === "isOutSup" || i === "isInIndy") {
              item[i + "Comp"] = item[i] === 1 ? "是" : "否";
            }
          }
          item.location = `${item.locationName || ""}${item.provinceName ||
            ""}${item.cityName || ""}${item.countyName || ""}`;
          this.currBreadCrumb &&
            this.$set(this.currBreadCrumb, "title", item.supName);
          this.$set(this, "basicInfoData", item || {});
          this.$set(
            this,
            "approvalOperInfoBO",
            res.data.data.approvalOperInfoBO
          );
        }
      });
      //联系信息
      qrySupplierLinkInfo({
        supinfoId: supid,
        supCode: supcode
      }).then(res => {
        if (res.data.code === "0") {
          this.supplierContactData = res.data.data.supContactBO || {};
          this.commonLinkInfoData =
            res.data.data.commonSupContactInfoBOList || [];
        }
      });
    },
    //产品信息
    getProductInfoData(supid, businessBillType, supcode) {
      let params = {
        supinfoId: supid,
        businessBillType: businessBillType,
        supCode: supcode,
        requestLimit: true
      };
      qrySupplierProductInfo(params).then(res => {
        if (res.data.code === "0") {
          this.productInfoData = res.data.data.rows || [];
        }
      });
    },
    //财务信息
    getFinanceInfoData(supid, businessBillType, supcode) {
      qrySupFinanceInfo({
        supInfoApplyId: supid,
        supCode: supcode,
        requestLimit: true
      }).then(res => {
        if (res.data.code === "0") {
          this.financeInfoData = res.data.data.supPayInfoBO || {};
        }
      });
    },
    //合作业绩
    getCooperationPerformanceData(supid, businessBillType, supcode) {
      let params = {
        supinfoId: supid,
        businessBillType: businessBillType,
        supCode: supcode,
        requestLimit: true
      };
      qrySupHisPerform(params).then(res => {
        if (res.data.code === "0") {
          if (
            res.data.data.supHisPerformBO.cooperEnterprise.charAt(
              res.data.data.supHisPerformBO.cooperEnterprise.length - 1
            ) === ","
          ) {
            res.data.data.supHisPerformBO.cooperEnterprise = res.data.data.supHisPerformBO.cooperEnterprise.substring(
              0,
              res.data.data.supHisPerformBO.cooperEnterprise.length - 1
            );
          }
          this.cooperationPerformanceData = res.data.data.supHisPerformBO || {};
        }
      });
    },
    //资质文件
    getCertificatesData(supid, businessBillType, supcode) {
      let params = {
        supinfoId: supid,
        businessBillType: businessBillType,
        supCode: supcode,
        requestLimit: true
      };
      qrySupplierQualificationFile(params).then(res => {
        if (res.data.code === "0") {
          this.certificatesData = res.data.data.rows || [];
        }
      });
    },
    // 签订合同业绩
    getSignContractData(supName, supCode) {
      // 查询签订合同业绩
      qrySignContract({
        pageNo: -1,
        pageSize: -1,
        supName: supName,
        supCode: supCode
      }).then(res => {
        if (res.data.code === "0") {
          this.signContractData = res.data.data.rows || [];
        }
      });
    },
    // 查询考核信息
    getAssessScoreInfoList(supName, supCode) {
      // 考核信息
      qryAssessScoreInfoList({
        pageNo: -1,
        pageSize: -1,
        supName: supName,
        supCode: supCode,
        requestLimit: true
      }).then(res => {
        if (res.data.code === "0") {
          this.supplierAssessmentData = res.data.data.rows || [];
        }
      });
    },
    // 查询状态信息
    getStatusInfoData(supId, businessBillType, supCode) {
      querySupplierFrozenOrDisableStatusList({
        supinfoId: supId,
        supCode: supCode,
        pageNo: 1,
        pageSize: 10,
        requestLimit: true
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.rows.map(item => {
            if (item.createTime !== "") {
              item.createTime = moment(item.createTime).format(
                "yyyy-MM-DD HH:mm"
              );
            }
            if (item.thawTime !== "") {
              item.thawTime = moment(item.thawTime).format("yyyy-MM-DD HH:mm");
            }
            if (item.updateTime !== "") {
              item.updateTime = moment(item.updateTime).format(
                "yyyy-MM-DD HH:mm"
              );
            }

            return item;
          });
          this.statusInfoData = res.data.data.rows || {};
        }
      });
    },
    // 查询历史中标金额
    getHistoryBidAmount(supCode) {
      // 中标金额
      qrySupBidAmountList({
        pageNo: -1,
        pageSize: -1,
        supCode: supCode
      }).then(res => {
        if (res.data.code === "0") {
          this.historyBidAmount = res.data.data.rows || [];
        }
      });
    },
    tableTopChange({ value }) {
      this.isFocus = value;
    },
    cancel() {
      this.$emit("cancel", false);
      this.basicInfoData = {}; //基本信息
      this.supplierContactData = {}; //供应商联系信息
      this.commonLinkInfoData = []; //常用联系人信息
      this.productInfoData = []; //产品信息
      this.financeInfoData = {}; //财务信息
      this.cooperationPerformanceData = {}; //合作业绩
      this.signContractData = []; //签订合同业绩 暂无数据
      this.supplierAssessmentData = []; // 供应商考核信息
      this.certificatesData = []; //资质文件信息
      this.statusInfoData = []; //状态信息
      this.historyBidAmount = []; //历史中标金额
      this.isFocus = "1";
    }
  }
};
</script>

<style scoped lang="scss">
.sub-contractor-detail-form-item {
  margin: 30px 20px;
}
.ccui-group-wrapper {
  /deep/ .el-table .el-table__body .cell {
    height: 36px;
    line-height: 36px;
  }
}
.form_item {
  width: 260px;
  /deep/ .el-input__icon {
    position: relative;
    right: -7px;
  }
}
.col-bottom {
  margin-bottom: 20px;
}
.rel {
  position: relative;
}
.sub-btnbox {
  text-align: right;
  margin-bottom: 20px;
}
/deep/.dic-dialog-supplier-detail .ccui-tab-wrapper .el-button--table-top span {
  font-weight: bold;
}
</style>
